import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { editPartnerPlan } from 'actions/partnerPlanForm'
import constants from 'constants'
import PartnerPlanStatusDisplayForm from 'views/PartnerPlans/PartnerPlanStatusDisplayForm'

class PartnerPlanStatusForm extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    partnerPlans: PropTypes.object.isRequired,
  }

  static defaultProps = {
    id: 'partnerPlanStatusForm',
  }

  _submit = (data) => {
    if (data.employee_id && data.year && data.planStatus) {
      const newData = { ...data, loggedin_employee_id: this.props.currentUser.EmployeeId }
      this.props.dispatch(editPartnerPlan(newData, this.props.id, constants.PARTNERPLAN.ROLE.MYPLANS, false))
    }
  }

  render() {
    const {
      modals, currentUser, hide, forms, id, partnerPlans,
    } = this.props
    return (
      <PartnerPlanStatusDisplayForm
        currentUser={currentUser}
        description=""
        dispatch={this.props.dispatch}
        forms={forms}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        modals={modals}
        partnerPlans={partnerPlans}
        title="Edit plan status"
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  partnerPlans: state.partnerPlans,
  partnerPlanForm: state.partnerPlanForm,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnerPlanStatusForm))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanStatusForm.js